var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#57454A",
    viewBox: "0 0 24 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6908 17.3834L5.71743 0.410034L0.530762 5.5967L11.3708 21.1567C10.3308 22.1967 10.3308 23.89 11.3708 24.93L13.2508 26.81C14.2908 27.85 15.9841 27.85 17.0241 26.81L22.6774 21.1567C23.7308 20.1167 23.7308 18.4234 22.6908 17.3834ZM3.99743 5.90337L5.71743 4.18337L17.0374 15.5034L13.2908 19.25L3.99743 5.90337ZM15.1441 24.9167L13.2641 23.0367L18.9174 17.3834L20.7974 19.2634L15.1441 24.9167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.08569599eb28066f7f943950617e60fa.svg";
export { ForwardRef as ReactComponent };